import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
import { TextJustifier } from './TextJustifier';
var EastAsianJustifier = /** @class */ (function (_super) {
    __extends(EastAsianJustifier, _super);
    function EastAsianJustifier(locale, lineJustification, justificationStyle) {
        if (locale === void 0) { locale = 'ja'; }
        if (lineJustification === void 0) { lineJustification = 'allButLast'; }
        if (justificationStyle === void 0) { justificationStyle = 'pushInKinsoku'; }
        locale = axCoerceString(locale);
        lineJustification = axCoerceString(lineJustification);
        justificationStyle = axCoerceString(justificationStyle);
        return _super.call(this, undefined, undefined) || this;
    }
    Object.defineProperty(EastAsianJustifier.prototype, "justificationStyle", {
        // AS -> JS Bindings
        // _justificationStyle: string;
        // _composeTrailingIdeographicSpaces: boolean;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'get justificationStyle', '');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'set justificationStyle', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EastAsianJustifier.prototype, "composeTrailingIdeographicSpaces", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'get composeTrailingIdeographicSpaces', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'set composeTrailingIdeographicSpaces', '');
        },
        enumerable: false,
        configurable: true
    });
    EastAsianJustifier.forceNativeConstructor = true;
    EastAsianJustifier.forceNativeMethods = true;
    return EastAsianJustifier;
}(TextJustifier));
export { EastAsianJustifier };
